const BASE_URL = "https://eureka-7b91fe4d0315.herokuapp.com/api";
const SR_SEARCH = "https://www.reddit.com/subreddits/search.json?q=";

export { BASE_URL, SR_SEARCH };
